
export default {
  ADD: 'RATINGS_ADD',
  LOAD: 'RATINGS_LOAD',
  DELETE: 'RATINGS_DELETE',
  UPDATE: 'RATINGS_UPDATE',
};


// WEBPACK FOOTER //
// ./modules/rating/constants/RatingsConstants.js